import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import ChargeHelper from 'features/Charge/chargeHelper';
import useCharge from 'features/Charge/useCharge';
import SystemHelper from 'features/System/systemHelper';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import DropdownMultiChoiceView from 'general/components/quybka/Others/DropdownMultiChoiceView';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import UIHelper from 'general/helpers/UIHelper';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';

EnergyBillListFilterView.propTypes = {
  onCancel: PropTypes.func,
  onApply: PropTypes.func,
  initialFilter: PropTypes.object,
};

function EnergyBillListFilterView({ onCancel, onApply, closeDropdown, initialFilter }) {
  // MARK: ---- PROPERTIES ----
  const [selectedAgency, setSelectedAgency] = useState()
  const [filterQ, setFilterQ] = useState('');
  const [filterMonth, setFilterMonth] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterAgencyId, setFilterAgencyId] = useState('');
  const [filterLandlordId, setFilterLandlordId] = useState('');
  const { managementObjectOptions } = useCharge();
  const [selectedManagementObject, setSelectedManagementObject] = useState('');
  useEffect(() => {
    setFilterQ(initialFilter?.q);
    setFilterMonth(initialFilter?.month);
    setFilterStatus(initialFilter?.status);
    setFilterAgencyId(ChargeHelper.Filter.chargeStationList.agencyId);
    setFilterLandlordId(ChargeHelper.Filter.chargeStationList.landlordId);
  }, [initialFilter]);

  // MARK: ---- METHODS ----
  const handleApplyFilter = () => {
    const newFilter = {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: filterQ,
      month: filterMonth,
      status: filterStatus,
    };
    if (onApply) onApply(newFilter);
    if (closeDropdown) closeDropdown();
  };
  const handleClearFilter = () => {
    const newFilter = {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: '',
      month: moment().format('YYYY-MM'),
      status: '',
    };
    if (onCancel) onCancel(newFilter);
    if (closeDropdown) closeDropdown();
  };

  const dropdownAgencyEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="agencyId_filter"
        name="agencyId_filter"
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${selectedManagementObject === '' ? 'disabled' : ''
              }`}
            type="button"
          >
            {selectedAgency
              ? selectedAgency?.name
              : selectedManagementObject === AgencyConstants.AgencyRole.INVESTOR
                ? 'Chọn nhà đầu tư'
                : 'Chọn chủ mặt bằng'}
          </button>
        }
        selectedValue={selectedAgency}
        subTitleType="email"
        dropdownMenuItems={[{ name: 'AGENCY', role: 'AGENCY' }]}
        getSubItems={async (item) => {
          return AgencyHelper.API.requestGetAgencyList({
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
            role:
              selectedManagementObject === AgencyConstants.AgencyRole.INVESTOR
                ? 'INVESTOR'
                : 'LANDLORD',
          }).then((data) => {
            return {
              values: data.agencies?.map((row) => ({
                id: row?.agencyId,
                name: row?.name,
                item: row,
                email: row?.email,
              })),
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedAgency(value);
          setFilterAgencyId(value?.id);
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        disabled={selectedManagementObject === ''}
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        defaultValue={{
          name: 'AGENCY',
          role: 'AGENCY',
        }}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedAgency(null);
              setFilterAgencyId('');
            })}
          </div>
        }
      />
    );
  }, [selectedAgency, selectedManagementObject]);

  return (
    <div className="py-4">
      <div className="row m-0 px-2">
        {/* tim kiem */}
        <div className="col-12 mb-4 px-2">
          <KTFormSearch
            name="search_filter"
            placeholder="Nhập để tìm kiếm..."
            value={filterQ}
            onSubmit={(text) => {
              setFilterQ(text);
            }}
          />
        </div>
        {/* ky hoa don */}
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Kỳ hoá đơn')}
          <KTFormInput
            name="month_filter"
            type={KTFormInputType.month}
            value={filterMonth}
            onChange={(value) => {
              setFilterMonth(value);
            }}
          />
        </div>
        {/* trang thai */}
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Trạng thái hoá đơn')}
          <DropdownMultiChoiceView
            items={SystemHelper.Data.EnergyBillStatusOptions}
            initialSelectedValues={filterStatus?.split(',') ?? []}
            onChange={(items) => {
              setFilterStatus(items?.join(','));
            }}
          />
        </div>
        {/* doi tuong quan ly */}
        <div className="col-sm-6 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Đối tượng quản lý')}
          <KTBSDropdown
            name="managementObject_filter"
            toggleElement={
              <button
                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                type="button"
              >
                {_.find(managementObjectOptions, (item) => item.value === selectedManagementObject)
                  ?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={selectedManagementObject}
            dropdownMenuItems={[{ name: 'Tất cả', value: '' }, ...managementObjectOptions]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setSelectedManagementObject(value);
              setSelectedAgency(null);
              setFilterAgencyId('');
              setFilterLandlordId('');
            }}
            isDropdownForm={true}
          />
        </div>
        {/* ndt nq hoac chu dat */}
        <div className="col-sm-6 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel(
            selectedManagementObject === AgencyConstants.AgencyRole.INVESTOR
              ? 'Nhà đầu tư NQ'
              : selectedManagementObject === AgencyConstants.AgencyRole.LANDLORD
                ? 'Chủ mặt bằng'
                : 'NĐT/Chủ mặt bằng',
            selectedManagementObject !== ''
          )}
          {dropdownAgencyEl}
        </div>
      </div>
      {/* actions */}
      <div
        className="px-4 pt-4 pb-0 d-flex align-items-center justify-content-end gap-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Xóa bộ lọc', handleClearFilter)}
        {UIHelper.buildGreenButton('Áp dụng', handleApplyFilter)}
      </div>
    </div>
  );
}

export default EnergyBillListFilterView;
